import { defineStore } from "pinia";
import type { Breakpoint, To, UIState } from "@/types/ui";

export const useUI = defineStore("ui", {
  state: () => {
    return {
      breakpoint: "sm",
      // These breakpoints should be adapted to the current library being used
      // Brakpoints defined by their minimum boundary
      breakpoints: {
        xs: -Infinity,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        "2xl": 1536,
      },
      appLogoProps: {
        color: "#747378",
        disabled: false,
        size: 145,
        to: {
          path: "/",
        },
      },
    } as UIState;
  },
  actions: {
    getBreakpoint() {
      let found: Breakpoint = "sm";
      const width = window.innerWidth;
      const map = this.breakpoints;
      (Object.entries(map) as [Breakpoint, number][]).forEach(([name, size]) => {
        if (width > size) found = name;
      });
      this.breakpoint = found;
      return found;
    },
    setAppLogoState(to: To, disabled: boolean) {
      if (typeof to !== "undefined") this.appLogoProps.to = to;
      if (typeof disabled !== "undefined") this.appLogoProps.disabled = disabled;
    },
    resetAppLogoState() {
      this.appLogoProps.to = { name: "home" };
      this.appLogoProps.disabled = false;
    },
  },
  getters: {
    currentBreakPointIsLowerThan: (state) => (reference: Breakpoint) => {
      if (state.breakpoint) {
        return state.breakpoints[state.breakpoint] < state.breakpoints[reference];
      }
      return false;
    },
    currentBreakPointIsLowerOrEqualThan: (state) => (reference: Breakpoint) => {
      if (state.breakpoint) {
        return state.breakpoints[state.breakpoint] <= state.breakpoints[reference];
      }
      return false;
    },
    currentBreakPointIsHigherThan: (state) => (reference: Breakpoint) => {
      if (state.breakpoint) {
        return state.breakpoints[state.breakpoint] > state.breakpoints[reference];
      }
      return false;
    },
    currentBreakPointIsHigherOrEqualThan: (state) => (reference: Breakpoint) => {
      if (state.breakpoint) {
        return state.breakpoints[state.breakpoint] >= state.breakpoints[reference];
      }
      return false;
    },
    /**
     * Takes a map of breakpoints to values and returns the closest applicable value.
     * Or else will return the provided default value
     * byBreakpoint({ md: 'hello', lg: 'Hi' }, 'Greetings')
     * @returns
     */
    // byBreakpoint(state) {
    //   return (config: Partial<Record<Breakpoint, any>>, defaultValue?: any) => {
    //     const keys = Object.keys(this.breakpoints) as Breakpoint[];
    //     const usedKeys = keys.filter((breakpoint) => !isNil(config[breakpoint]));
    //     const foundKey = findRight(usedKeys, (breakpoint) =>
    //       this.currentBreakPointIsHigherOrEqualThan(breakpoint)
    //     );
    //     return foundKey ? config[foundKey] : defaultValue;
    //   };
    // },
    // boolToYesNo: (state) => (arg: unknown) => (arg ? "Sì" : "No"),
  },
});
